export default {
  HEADER: {
    MENU: {
      TITLE: 'Hikarusa Menu',
      HOME: 'Home',
      SHOP: 'Shop',
      ABOUT: 'About',
      GET_TO_KNOW: 'Our Story',
      FAQ: 'Frequently Asked Questions',
      CARE_MANUAL: 'Care Instruction',
      WASHING_MANUAL: 'Washing Instruction',
      REGISTER_RESELLER: 'Become Reseller',
      SIZE_RECOMMENDATION: 'Size Recommendation',
      CONTACT_US: 'Contact Us',
      RESELLER: 'Reseller',
      SIGNIN: 'Sign In',
      SIGNUP: 'Sign up',
      LOGOUT: 'Logout',
      ACCOUNT_DETAIL: 'Account Detail'
    }
  }
}
